import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { ChannelsSearchResults } from './ChannelsSearchResults'
import { VodSearchResults } from './VodSearchResult'
import Channel from '@/shared/classes/channels/channel'
import { usePopperSearchResultsLogic } from '@/shared/hooks'

interface IPopperSearchResult {
    channels: Array<Channel>
    query: string
    onClick: () => void
}

export const PopperSearchResult = ({
    channels,
    query,
    onClick,
}: IPopperSearchResult) => {
    const { t: translate } = useTranslation()
    const {
        isShowMoreVod,
        isShowMoreCatchup,
        isShowMoreTV,
        isShowMoreEpg,
        ref,
        setIsShowMoreVod,
        setIsShowMoreCatchup,
        setIsShowMoreTV,
        setIsShowMoreEpg,
        finallyFiltered,
        channelsFuturePlaying,
        vodSearchResults,
        catchupSearchResults,
        container,
    } = usePopperSearchResultsLogic(channels, query)

    return (
        <Box ref={ref} sx={container}>
            {finallyFiltered.length !== 0 &&
                !isShowMoreVod &&
                !isShowMoreCatchup &&
                !isShowMoreEpg && (
                    <ChannelsSearchResults
                        channelsSet={finallyFiltered}
                        setShowMore={setIsShowMoreTV}
                        showMore={isShowMoreTV}
                        onItemClick={onClick}
                    />
                )}
            {vodSearchResults.length !== 0 &&
                !isShowMoreTV &&
                !isShowMoreEpg &&
                !isShowMoreCatchup && (
                    <Box mt="16px">
                        <VodSearchResults
                            title={translate<string>('vodLabel')}
                            emptyLabel={translate<string>('noVodFound')}
                            setShowMore={setIsShowMoreVod}
                            showMore={isShowMoreVod}
                            vodItemsSet={vodSearchResults}
                            onItemClick={onClick}
                        />
                    </Box>
                )}
            {catchupSearchResults.length !== 0 &&
                !isShowMoreTV &&
                !isShowMoreEpg &&
                !isShowMoreVod && (
                    <Box mt="16px">
                        <VodSearchResults
                            title={translate<string>('catchupLabel')}
                            emptyLabel={translate<string>('noCatchupFound')}
                            setShowMore={setIsShowMoreCatchup}
                            showMore={isShowMoreCatchup}
                            vodItemsSet={catchupSearchResults}
                            onItemClick={onClick}
                        />
                    </Box>
                )}
            {channelsFuturePlaying.length !== 0 &&
                !isShowMoreTV &&
                !isShowMoreVod &&
                !isShowMoreCatchup && (
                    <Box mt="16px">
                        <ChannelsSearchResults
                            channelsSet={channelsFuturePlaying}
                            setShowMore={setIsShowMoreEpg}
                            showMore={isShowMoreEpg}
                            onItemClick={onClick}
                        />
                    </Box>
                )}
        </Box>
    )
}
